export const useThrottle = (callback, limit) => {
  let timeOut = null;
  return (...params) => {
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      callback(...params);
    }, limit);
  };
};

export default {};
